import { Component, OnDestroy, OnInit } from '@angular/core';
import { NicaToastService, ToastItem } from '../../services/nica-toast.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-nica-toast',
  templateUrl: './nica-toast.component.html',
  styleUrls: ['./nica-toast.component.css']
})
export class NicaToastComponent implements OnInit, OnDestroy {
  toasts: ToastItem[] = [];
  private $destroy: Subject<void> = new Subject()

  constructor(private toastService: NicaToastService) { }
  ngOnDestroy(): void {
    this.$destroy.next()
    this.$destroy.complete()
  }

  ngOnInit() {
    this.toastService.toasts$.pipe(takeUntil(this.$destroy)).subscribe(list => {
      this.toasts = list;
      console.log(list)
    });
  }

  closeToast(id: string) {
    this.toastService.removeToast(id);
  }
}
